import React from 'react';
import { Select, SelectProps } from 'antd';

interface SearchableSelectProps extends SelectProps {
  /**
   * Placeholder del select
   */
  placeholder?: string;
}

/**
 * Componente Select reutilizable con búsqueda pre-configurada
 * Incluye: showSearch, allowClear, filterOption, size="large"
 */
export const SearchableSelect: React.FC<SearchableSelectProps> = ({ 
  placeholder = "Buscar...",
  style = {},
  ...restProps 
}) => {
  return (
    <Select
      showSearch
      placeholder={placeholder}
      size="large"
      allowClear
      optionFilterProp="children"
      filterOption={(input, option) => {
        const label = option?.label?.toString().toLowerCase() || '';
        return label.includes(input.toLowerCase());
      }}
      style={{ width: '100%', ...style }}
      {...restProps}
    />
  );
};

